import { initializeApp, getApps } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBMypCgIHl7zvD_tXH97oQLebrjmQCdr-0',
  authDomain: 'aidfone-e6a5c.firebaseapp.com',
  databaseURL: 'https://aidfone-e6a5c-default-rtdb.firebaseio.com',
  projectId: 'aidfone-e6a5c',
  storageBucket: 'aidfone-e6a5c.firebasestorage.app',
  messagingSenderId: '455019613037',
  appId: '1:455019613037:android:8eca8c7996803adfa36864',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const database = getDatabase(app);
